<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'
import CustomDialogIcon from './CustomDialogIcon.vue'

const props = defineProps({
  masterEntityId: {
    type: Number,
    default: null,
  },
  selectedRowsId: {
    type: Array,
    default: () => [],
  },
  grid: Object,
  entityLock: {
    type: Object,
    required: false,
  },
  onDelete: {
    type: Function,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  }
})

const i18n = getI18n()

const isLockedByAnother = computed(() => {
  if (!props.entityLock) return false

  if (props.masterEntityId != null) {
    return props.entityLock.isLocked(false, props.masterEntityId)
  }

  if (!props.selectedRowsId?.length) return false
  return props.selectedRowsId.some(id => props.entityLock.isLocked(false, id))
})

const isDisabled = computed(() => {
  return props.selectedRowsId.length === 0 || isLockedByAnother.value || props.disabled
})

const onDelete = async() => {
  if (!isDisabled.value) {
    await props.onDelete(props.selectedRowsId).then(res => {
      props.grid?.instance.refresh()
    })
  }
}
</script>

<template>
  <slot>
    <custom-dialog-icon
      icon="trash"
      :hint="i18n.t('common.delete')"
      :confirm-message="i18n.t('common.confirmDelete', 2)"
      :yes-text="i18n.t('common.yes')"
      :no-text="i18n.t('common.no')"
      :on-confirm="onDelete"
      :show-title="false"
      :disabled="isDisabled"
    />
  </slot>
</template>
